import { cn } from "../utils";

export type PillToggleItem = {
  label: string;
  value: string;
  accentLabel?: string;
};

type Props = {
  items: PillToggleItem[];
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
};

export default function PillToggleGroup({
  items,
  value,
  onValueChange,
  className,
}: Props) {
  return (
    <div
      className={cn(
        "flex w-fit shrink-0 grow-0 basis-auto items-center gap-1 rounded-full bg-grey-150 p-0.5",
        className,
      )}
    >
      {items.map((item) => {
        const isSelected = value === item.value;

        return (
          <button
            key={item.value}
            type="button"
            onClick={() => onValueChange(item.value)}
            className={cn(
              "flex cursor-pointer items-center justify-center gap-2 rounded-full border px-4 py-1.25 text-sm font-semibold whitespace-nowrap transition-all",
              {
                "border-border bg-white text-text-primary": isSelected,
                "border-transparent text-text-primary hover:bg-black/5":
                  !isSelected,
              },
            )}
          >
            <span
              className={cn("transition-opacity", {
                "opacity-70": !isSelected,
                "opacity-100": isSelected,
              })}
            >
              {item.label}
            </span>
            {item.accentLabel && (
              <span className="text-xs font-semibold text-tertiary-400 underline decoration-dotted underline-offset-2 opacity-100">
                {item.accentLabel}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
